import { createReducer } from '@reduxjs/toolkit';

import { getCurrentInstitution } from 'redux/selectors/institutions';
import { saveOrgLevelProfileSettings } from 'redux/actions/org-level-profile';
import { initialRootState } from './index';

export default createReducer(initialRootState, builder => {
  builder.addCase(saveOrgLevelProfileSettings.fulfilled, (state, action) => {
    const currentInstitution = getCurrentInstitution(state);

    Object.assign(currentInstitution, action.payload);
  });
});
